<template>
  <div class="language-selector">
    <div v-if="showDropdown">
      <a class="header-widget-icon" href="javascript:void(0)">
        <img :src="currentLanguageFlag" alt="" class="h-23px w-23px rounded-sm" />
      </a>
      <!-- Language dropdown -->
      <div :ref="dropdownId" class="dropdown-notifications dropdown-languages" uk-dropdown=" pos: top-right;mode:click">
        <!-- notification contents -->
        <div class="dropdown-notifications-content" data-simplebar>
          <!-- list -->
          <ul style="background-color: white;">
            <template v-for="(item, i) in languages">
              <li v-if="item.lang !== normalizedCurrentLanguage" :key="i" :class="{
                'navi-item-active': isActiveLanguage(item.lang),
              }" class="navi-item">
                <a class="navi-link uk-dropdown-close" href="#" :data-lang="item.lang" @click.prevent="selectLanguage">
                  <span class="symbol symbol-20 mr-3">
                    <img :src="item.flag" alt="" class="h-23px w-23px rounded-sm" />
                  </span>
                  <span class="navi-text">{{ item.name }}</span>
                </a>
              </li>
            </template>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18nService from "@/core/services/i18n.service.js";
import { backendHttpClient } from "@/core/services/api.service";
import { integrationMixin } from "@/core/mixin/integration.mixin";

export default {
  name: "LanguageSelector",
  mixins: [integrationMixin],
  props: {
    showDropdown: {
      type: Boolean,
      default: true
    },
    dropdownId: {
      type: String,
      default: "languageDropdown"
    }
  },
  data() {
    return {
      languages: i18nService.languages,
      currentLanguage: i18nService.getActiveLanguage(),
    }
  },
  computed: {
    normalizedCurrentLanguage() {
      return this.normalizeLangCode(this.currentLanguage);
    },
    currentLanguageFlag() {
      const lang = this.languages.find(l => l.lang === this.normalizedCurrentLanguage);
      return lang ? lang.flag : this.languages[0].flag;
     }
  },

  watch: {
    "$i18n.locale": {
      immediate: true,
      handler(newLocale) {
        const lang = this.normalizeLangCode(newLocale || i18nService.getActiveLanguage());
        this.currentLanguage = lang;
      }
    }
  },
  methods: {
    normalizeLangCode(lang) {
      const normalized = String(lang || "").toLowerCase().split("-")[0];
      const exists = this.languages.some((l) => l.lang === normalized);
      return exists ? normalized : "tr";
    },
    selectLanguage(e) {
      let lang;
      // Event'ten dil al (header için) veya direkt parametre (homepage için)
      if (e && e.target) {
        const el = e.target.closest(".navi-link");
        lang = el && el.getAttribute("data-lang");
      } else {
        lang = e; // Homepage'den direkt dil kodu gelir
      }
      if (!lang) return;
      lang = this.normalizeLangCode(lang);
      if (lang === this.currentLanguage) return;

      i18nService.setActiveLanguage(lang);
      this.currentLanguage = lang;

      // Vue i18n locale'ini güncelle
      if (this.$i18n) {
        this.$i18n.locale = lang;
      }
      window.dispatchEvent(new CustomEvent("app-language-changed", { detail: { lang } }));

      // Her durumda API çağrısı yap
      this.callLanguageChangeAPI(lang);
    },

    callLanguageChangeAPI(lang) {
      const token = this.secureLocalStorage("token");
      if (!token) {
        localStorage.setItem("activeLanguage", lang);
        return;
      }

      return backendHttpClient.post('api/user/change-language',
        { code: lang },
        {
          validateStatus: () => true
        }
      ).then(() => {
        localStorage.setItem("activeLanguage", lang);
      });
    },
    isActiveLanguage(current) {
      return this.normalizedCurrentLanguage === current;
    }
  }
};
</script>

<style scoped>
.language-selector {
  display: inline-block;
}
</style>
